import { IFrameMessage } from "./iframe-message";

/**
* Usage example
* const iframeChildService = new IFrameChildService();
* iframeChildService.onMessage(message => {
*     console.log('IFrameMessage received from parent:', message);
* });
 */
export class IFrameChildService {
    private messageHandlers: ((message: IFrameMessage) => void)[] = [];

    constructor() {
        window.addEventListener('message', this.handleMessage.bind(this));
    }

    public sendMessageToParent(message: IFrameMessage): void {
        window.parent.postMessage(message, '*');
    }

    public onMessage(handler: (message: IFrameMessage) => void): void {
        this.messageHandlers.push(handler);
    }

    private handleMessage(event: MessageEvent): void {
        const message: IFrameMessage = event.data;
        this.messageHandlers.forEach(handler => handler(message));
    }
}
